import {maxLength, required} from '@vuelidate/validators';
import {computed, ref} from 'vue';
import type {FormElementItem} from '~/lib/types/formTypes';
import {getRiskLevelText, rootCauseOptions} from '~/lib/riskHelper';
import type {ExistingRiskForm, NewRiskForm} from '~/lib/types/riskTypes';
import FineAndKinneyToolComponent from '~/components/risks/FineAndKinneyToolComponent.vue';

export const riskResourceFormLabels = {
	description: 'Omschrijving',
	level: 'Risicoklasse',
	title: 'Risico',
	type: 'Risico type'
} satisfies Partial<Record<keyof (NewRiskForm | ExistingRiskForm), string>>;

export default (riskTypes: string[], initialValue?: ExistingRiskForm) => {
	const formFieldsNewRisk = ref<NewRiskForm>({
		title: '',
		description: '',
		level: 'MEDIUM',
		type: '',
		tag: 'NEW_RISK',
		suggestedMeasures: [],
		rootCauses: [],
		rootCausesExplanation: ''
	} satisfies NewRiskForm);

	const formFieldsExistingRisk = ref<ExistingRiskForm>({
		...initialValue as ExistingRiskForm
	});

	const rootCausesExplanationAttributes = computed(() => {
		if (formFieldsNewRisk.value.rootCauses !== undefined && formFieldsNewRisk.value.rootCauses?.length > 0) {
			return {};
		}

		if (formFieldsExistingRisk.value.rootCauses !== undefined && formFieldsExistingRisk.value.rootCauses?.length > 0) {
			return {};
		}

		return {
			disabled: 'disabled'
		};
	});

	const formSchema: Array<FormElementItem> = [
		{
			key: 'title',
			type: 'text',
			label: riskResourceFormLabels.title,
			validators: {
				required,
				maxLength: maxLength(255)
			}
		},
		{
			key: 'description',
			type: 'textarea',
			label: riskResourceFormLabels.description,
			validators: {
				required,
				maxLength: maxLength(1000)
			},
			attrs: {
				rows: 5
			}
		},
		{
			key: 'level',
			type: 'select',
			label: riskResourceFormLabels.level,
			validators: {
				required
			},
			options: [
				{
					value: 'LOW',
					label: getRiskLevelText('LOW')
				},
				{
					value: 'MEDIUM',
					label: getRiskLevelText('MEDIUM')
				},
				{
					value: 'HIGH',
					label: getRiskLevelText('HIGH')
				}
			]
		},
		{
			key: 'fineAndKinneyTool',
			type: 'component',
			label: 'Fine and Kinney Tool',
			validators: {},
			component: FineAndKinneyToolComponent
		},
		{
			key: 'type',
			type: 'select',
			label: riskResourceFormLabels.type,
			options: riskTypes.map((type) => ({
				value: type,
				label: type
			})),
			validators: {
				maxLength: maxLength(255)
			}
		},
		{
			key: 'rootCauses',
			type: 'checkbox',
			label: 'Grondoorzaken',
			options: rootCauseOptions,
			validators: {}
		},
		{
			key: 'rootCausesExplanation',
			type: 'textarea',
			label: 'Toelichting gekozen grondoorzaken',
			validators: {
				maxLength: maxLength(1000)
			},
			attrs: rootCausesExplanationAttributes
		}
	];

	return {
		formSchema,
		formFieldsExistingRisk,
		formFieldsNewRisk
	};

};
